import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PhoneForm from '../../../components/PhoneForm';
import { useAuthentication } from '../../../state/Authentication';

const PhoneEdit: React.FC = () => {
  const {
    state: { user },
  } = useAuthentication();
  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {
    if (!user.phonePrimary) {
      history.replace('/gegevens/aanmeldsleutels/telefoon/toevoegen');
    }
  }, [user]);

  // Get the redirectUrl from the query parameters
  const queryParams = new URLSearchParams(location.search);
  const redirectUrl = queryParams.get('redirectUrl') || '';

  return <PhoneForm copyIdentifier="edit" redirectUrl={redirectUrl} />;
};

export default PhoneEdit;
